import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useState, useEffect, createContext } from "react";
import { userManager } from "./auth_helper";
import jwtDecode from "jwt-decode";

const UserContext = createContext();

const UseAuthRoute = ({ children }) => {
  const [state, setState] = useState({
    token: "",
    user_id: "",
    roles: []
  });

  const [loading, setLoading] = useState(true); // 🔥 new state
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loadUser = async () => {
      try {
        const user = await userManager.getUser();

        if (!user) {
          setLoading(false);
          return;
        }

        const decoded = jwtDecode(user.access_token);

        setState({
          token: user.access_token,
          user_id: decoded.sub,
          roles: decoded.realm_access?.roles || []
        });

        setLoading(false);
      } catch (err) {
        console.error("Error loading user:", err);
        setLoading(false);
      }
    };

    loadUser();
  }, [location]);

  // ⏳ 1️⃣ While checking Keycloak session, show loader instead of Unauthorized
  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "80px" }}>
        <p>Loading...</p>
      </div>
    );
  }

 if (!state.token) {
  sessionStorage.setItem(
    "requested_path",
    location.pathname + location.search
  );
  return <Navigate to="/" replace />;
}


  // ✅ 3️⃣ Logged in → show app
  return (
    <UserContext.Provider value={[state, setState]}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UseAuthRoute };
